import React, { FC, useEffect, useMemo, useState } from 'react';
import { CdsComboBoxProps } from './CDSComboBoxProps';
import { TextField } from '@mui/material';
import {
  debounce,
  filterOptions,
} from '../ResponsibleTab/ProjectResponsibleForm/ResponsibleField/ResponsibleAutocomplete/utils';
import checkmark from '@ingka/ssr-icon/paths/checkmark';

import { searchUsers } from '../../store/utils/graphUserApi';
import { emailRegex } from '../ResponsibleTab/ProjectResponsibleForm/ResponsibleField/ResponsibleAutocomplete/ResponsibleAutocomplete';
import Autocomplete from '@mui/material/Autocomplete';
import { MenuItem } from '@ingka/combobox';

const CdsComboBox: FC<CdsComboBoxProps> = ({
  value,
  onChange,
  id,
  options,
  required,
  error,
  label,
  testId,
  additionalStyles,
}) => {
  const [allUsersFiltered, setAllUsersFiltered] = useState([]);
  const usersMap = useMemo(() => {
    const userMap = new Map();
    options
      .filter((user) => user.email)
      .forEach((user) => {
        userMap.set(user.email.toLowerCase(), user);
      });
    return userMap;
  }, [options]);

  useEffect(() => {
    searchUsersFn('');
  }, []);

  const searchUsersFn = async (inputValue: string) => {
    const dbUsersFiltered = filterOptions(usersMap, inputValue);

    if (inputValue.length < 3 || usersMap.has(inputValue)) {
      checkForAbsenceAndStore(inputValue, dbUsersFiltered);
      return;
    }

    const usersResponse = await searchUsers(inputValue);
    const apiUsersFiltered = usersResponse
      .map((apiUser) => {
        return { name: apiUser.displayName, email: apiUser.mail };
      })
      .filter((apiUser) => !usersMap.has(apiUser.email.toLowerCase()));

    checkForAbsenceAndStore(inputValue, [
      ...dbUsersFiltered,
      ...apiUsersFiltered,
    ]);
  };

  const checkForAbsenceAndStore = (inputValue: string, usersArr: any[]) => {
    const usersReduced =
      usersArr.length >= 10 ? usersArr.slice(0, 10) : usersArr;

    if (emailRegex.test(inputValue) && !usersReduced.length) {
      usersReduced.push({
        email: inputValue,
        name: 'Add',
      });
    }

    setAllUsersFiltered(usersReduced);
  };

  const debouncedSetSearchTerm = useMemo(
    () => debounce(searchUsersFn, 500),
    [],
  );
  return (
    <Autocomplete
      fullWidth
      value={value ? value : ''}
      onChange={(_, value) => {
        onChange(value?.email || value);
      }}
      id={id}
      options={allUsersFiltered}
      onInputChange={(event, newInputValue) =>
        debouncedSetSearchTerm(newInputValue)
      }
      isOptionEqualToValue={(option, value) => {
        if (!value) return true;
        return option.email === value;
      }}
      getOptionLabel={(option) =>
        option?.email ? `${option.name} - ${option.email}` : option
      }
      filterOptions={(x) => x}
      data-testid={testId}
      renderOption={(props, option) => (
        <MenuItem
          id={option?.email}
          title={option?.email ? `${option.name} - ${option.email}` : option}
          onClick={() => onChange(option?.email || option)}
          leadingIcon={value === option.email ? checkmark : null}
        />
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={additionalStyles}
          error={error}
          label={required ? label + ' *' : label}
        />
      )}
    />
  );
};

export default CdsComboBox;
